import * as React from 'react';

import { Contact, Layout, Map, SEO } from '../components';

export default function ContactPage() {
  return (
    <Layout>
      <SEO title="Contact Us" />
      <Contact />
      <Map />
    </Layout>
  );
}
